import { Section } from "../Model/Section";
import { v4 as uuidv4 } from 'uuid';
export class SectionsFactory {
    constructor(questionFactory) {
        this.questionFactory = questionFactory;
    }
    createNewSection(form) {
        return new Section(form, uuidv4(), // id
        '', // name
        '', // description
        true, // status
        0, // position
        true, // required
        '100%', // width
        null, // parentId
        new Date, // date_created
        new Date, // date_updated
        null, // date_disabled
        []);
    }
    createSectionFromState(form, state) {
        const section = new Section(form, state.id, state.name, state.description, state.status, state.position, state.required, state.width, state.parentId, state.date_created, state.date_updated, state.date_disabled, []);
        const questions = state.questions.map(state => this.questionFactory.createQuestionFromState(form, section, state));
        for (const question of questions) {
            section.addQuestion(question);
        }
        return section;
    }
}
